import React, { useState, useEffect } from 'react'
import AssessmentWrapper from '../../AssessmentWrapper'
import { Modal } from "antd";
import { FaChevronRight } from "react-icons/fa";
import { Draggable, Droppable } from "react-drag-and-drop";
import { addAssessment } from '../../../../services/assessment';
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { assessmentAtom } from "../../../../state/assessment"
import { MODULE_1_INSTANCES } from '../../../../data/moduleInstances'
import Close from "../../../../resources/imgs/modal/close.svg";
import Progress from "../../progress";
import Plate from "../../../../resources/imgs/assessment/plate.svg"
import HelpBtn from "../../../../resources/imgs/assessment/helpBtn.svg"

import Tasty_pasta from "../../../../resources/imgs/assessment/dishes2/tasty-pasta.png"
import Lamb_steak from "../../../../resources/imgs/assessment/dishes2/lamb-steak.png"
import Chicken_steak from "../../../../resources/imgs/assessment/dishes2/chicken-steak.png"
import Steak from "../../../../resources/imgs/assessment/dishes2/Rectangle.png"
import Flat_lay from "../../../../resources/imgs/assessment/dishes2/flat-lay.png"
import Rectangle1 from "../../../../resources/imgs/assessment/dishes2/Rectangle1.png"
import Rectangle2 from "../../../../resources/imgs/assessment/dishes2/Rectangle2.png"

// Dynamic image loading function for numbered character images
const getCharacterImage = (name, imageNumber) => {
  // Use URL encoding to handle spaces in filenames
  const imagePath = `${process.env.PUBLIC_URL}/images/characters/${name}/${name}%20${imageNumber}.png`;
  return imagePath;
};

var initialRes = {
  module: 1,
  moduleKey: "guest_reactions",
  guestReactions: []
}

var initialVal = {
  personName: "Roy",
  favoriteDish: "Pasta",
  secondDish: "Salad",
  detestedDish: "Soup",
  seatingOrder: 0,
  isCorrect: true
}

export default function Index(props) {
  const assessment = useRecoilValue(assessmentAtom);

  // Helper function to shuffle an array
  const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  // Generate initial data from MODULE_1_INSTANCES
  const [initialData, setInitialData] = useState(() => {
    const module1BData = MODULE_1_INSTANCES['1B'];
    if (!module1BData || !module1BData.guests) {
      // Fallback data if module data not available
      return [];
    }
    
    // Map dish names to dish images
    const dishImages = {
      "Pasta": Tasty_pasta,
      "Lamb": Lamb_steak,
      "Chicken": Chicken_steak,
      "Steak": Steak,
      "Fish": Rectangle2,
      "Vegetarian": Flat_lay,
      "Shrimp": Rectangle1
    };
    
    // Convert module data to component format
    return module1BData.guests.map(guest => {
      // Create dish data with original indices
      const originalDishData = guest.dishes.map((dish, index) => ({
        emotion: getCharacterImage(guest.name, dish.image),
        dish: dishImages[dish.food] || Flat_lay,
        dishName: dish.food,
        rank: dish.rank,
        originalIndex: index
      }));
      
      // Shuffle the dish data to randomize presentation order
      const shuffledDishData = shuffleArray(originalDishData);
      
      // Create answer array based on shuffled positions
      // Each element represents which shuffled position (1-based) should go in each drop zone
      const answer = [0, 0, 0];
      shuffledDishData.forEach((dish, shuffledIndex) => {
        if (dish.rank === 3) answer[0] = shuffledIndex + 1; // Favorite dish position in shuffled array
        if (dish.rank === 2) answer[1] = shuffledIndex + 1; // Second favorite position in shuffled array
        if (dish.rank === 1) answer[2] = shuffledIndex + 1; // Least favorite position in shuffled array
      });
      
      return {
        name: guest.name,
        data: shuffledDishData,
        answer: answer
      };
    });
  })

  // Get emotions from real data (first guest as example)
  const [emotions, setEmotions] = useState(() => {
    const firstGuest = MODULE_1_INSTANCES['1A'].guests[0];
    return firstGuest ? firstGuest.emotions : ["Unimpressed", "Compassionate", "Delighted"];
  })
  const [cnt, setCnt] = useState(0);
  const [data, setData] = useState([{ name: "Trish", data: [{ emotion: "", dish: "", dishName:"" }, { emotion: "", dish: "" }, { emotion: "", dish: "" }], answer: [1, 2, 3] }])

  const [open, setOpen] = useState(false);
  const [dragIndex, setDragIndex] = useState([0, 0, 0])
  const [dropIndex, setDropIndex] = useState([0, 0, 0])

  useEffect(() => {
    let matchedData = props.cardData.map(card => {
      return initialData.find(person => person.name === card.name)
    }).filter(Boolean) // Filter out undefined values
    
    // Only set data if we have valid matches
    if (matchedData.length > 0) {
      setData(matchedData)
    }
  }, [])

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const handleDrop = ( val, idx ) => {
    let dropArr = [...dropIndex]
    let dragArr = [...dragIndex]
    
    // Check if there was a previous item in this slot
    const previousItemAtSlot = dropArr[idx];
    
    // If there was a previous item, make it available for dragging again
    if (previousItemAtSlot && previousItemAtSlot > 0) {
      dragArr[previousItemAtSlot - 1] = 0; // Make previous item draggable again
    }
    
    // Place new item in the slot
    dropArr[idx] = val;
    dragArr[val - 1] = 1; // Mark new item as used
    
    setDropIndex(dropArr)
    setDragIndex(dragArr)
  }

  const nextStep = async () => {
    const isCorrect = JSON.stringify(dropIndex) === JSON.stringify(data[cnt].answer);
    
    initialVal = {
      personName: data[cnt].name,
      favoriteDish: data[cnt].data[dropIndex[0]-1]?.dishName,
      secondDish: data[cnt].data[dropIndex[1]-1]?.dishName,
      detestedDish: data[cnt].data[dropIndex[2]-1]?.dishName,
      seatingOrder: 0,
      isCorrect: isCorrect
    }

    // Record score for cognitive assessment if available
    if (props.recordScore) {
      props.recordScore(isCorrect, {
        questionId: cnt + 1,
        guestName: data[cnt].name,
        userAnswers: dropIndex,
        correctAnswers: data[cnt].answer,
        questionType: 'food-preference-ranking'
      });
    }

    initialRes.guestReactions.push(initialVal);
    setDropIndex([0, 0, 0])
    setDragIndex([0, 0, 0])

    // Check if we've completed all 6 guests
    if (initialRes.guestReactions.length === 6) {
      // All 6 guests completed - wait for score popup then transition
      const delay = isCorrect ? 2500 : 500; // Longer delay if correct (to show popup)
      
      setTimeout(() => {
        // Module complete
        if (props.handleModuleComplete) {
          console.log('🎯 Module1_4 completing via handleModuleComplete');
          props.handleModuleComplete({
            completedQuestions: initialRes.guestReactions.length,
            totalQuestions: 6,
            correctAnswers: initialRes.guestReactions.filter(r => r.isCorrect).length,
            allAnswers: initialRes.guestReactions,
            moduleType: '1B'
          });
        } else if (props.nextPage) {
          console.log('🎯 Module1_4 completing via nextPage (fallback)');
          // Fallback to old API
          console.log('Module 1B completed - fallback mode');
          props.nextPage();
        }
      }, delay);
    } else {
      // Move to next guest
      setCnt(cnt + 1)
    }
  }

  // Safety check: ensure we have valid data before rendering
  if (!data[cnt]) {
    return (
      <div className="module1-main">
        <div className="module1-wrap">
          <div className="module1-content-wrap">
            <div className="module1-logo">Module 1</div>
            <div className="module1-body">
              <div className="module1-title">Loading...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="module1-main">
      <div className="module1-wrap">
        <Progress number="01." percent={1 / 8} />
        <div className="module1-content-wrap">
          <div className="module1-logo">Module 1</div>
          <div className="module1-body">
            <div className="module1-title">
              Determine each guest's favorite special based on their facial expression upon hearing each special.
            </div>
            <div className="module1-content1">
              Drag the dish to the appropriate category based on the guest's expression in the image
            </div>
          </div>
        </div>
      </div>

      <div className="module1-title name">
        { data[cnt].name }
      </div>
      <div className="module1-select-container">
        <div className='module1-drop-container'>
          <Droppable
            className=""
            types={["item"]}
            onDrop={(data) => handleDrop(parseInt(data.item, 10), 0)}
          >
            {dropIndex[0]?
              <div className='module1-drag-wrap module1-drop-style'>
                <img className='module1-drag-img1' src={data[cnt].data[dropIndex[0]-1].emotion} />
                <img className='module1-drag-img2' src={data[cnt].data[dropIndex[0]-1].dish} />
              </div> :
              <div className='module1-drop-wrap'>
                <div className='module1-order'>a. Favorite dish</div>
                <img src={Plate} />
              </div>
            }
          </Droppable>

          <Droppable
            className=""
            types={["item"]}
            onDrop={(data) => handleDrop(parseInt(data.item, 10), 1)}
          >
            {dropIndex[1]?
              <div className='module1-drag-wrap module1-drop-style'>
                <img className='module1-drag-img1' src={data[cnt].data[dropIndex[1]-1].emotion} />
                <img className='module1-drag-img2' src={data[cnt].data[dropIndex[1]-1].dish} />
              </div> :
              <div className='module1-drop-wrap'>
                <div className='module1-order'>b. Second favorite dish</div>
                <img src={Plate} />
              </div>
            }
          </Droppable>

          <Droppable
            className=""
            types={["item"]}
            onDrop={(data) => handleDrop(parseInt(data.item, 10), 2)}
          >
            {dropIndex[2]?
              <div className='module1-drag-wrap module1-drop-style'>
                <img className='module1-drag-img1' src={data[cnt].data[dropIndex[2]-1].emotion} />
                <img className='module1-drag-img2' src={data[cnt].data[dropIndex[2]-1].dish} />
              </div> :
              <div className='module1-drop-wrap'>
                <div className='module1-order'>c. Least Favorite dish</div>
                <img src={Plate} />
              </div>
            }
          </Droppable>
        </div>

        <div className='module1-drag-container'>
          <Draggable type="item" data={1}>
            <div className='module1-drag-wrap' style={{ backgroundColor: !dragIndex[0] && "white", border: !dragIndex[0] && "solid 2px #F277C7" }}>
              {!dragIndex[0] && <img className='module1-drag-img1' src={data[cnt].data[0].emotion} />}
              {!dragIndex[0] && <img className='module1-drag-img2' src={data[cnt].data[0].dish} />}
            </div>
          </Draggable>

          <Draggable type="item" data={2}>
            <div className='module1-drag-wrap' style={{ backgroundColor: !dragIndex[1] && "white", border: !dragIndex[1] && "solid 2px #F277C7" }}>
              {!dragIndex[1] && <img className='module1-drag-img1' src={data[cnt].data[1].emotion} />}
              {!dragIndex[1] && <img className='module1-drag-img2' src={data[cnt].data[1].dish} />}
            </div>
          </Draggable>

          <Draggable type="item" data={3}>
            <div className='module1-drag-wrap' style={{ backgroundColor: !dragIndex[2] && "white", border: !dragIndex[2] && "solid 2px #F277C7" }}>
              {!dragIndex[2] && <img className='module1-drag-img1' src={data[cnt].data[2].emotion} />}
              {!dragIndex[2] && <img className='module1-drag-img2' src={data[cnt].data[2].dish} />}
            </div>
          </Draggable>
        </div>
      </div>

      <div className='next-btn-group'>
        <div className='help-btn-group'>
          <div className='help-btn-effect1'></div>
          <div className='help-btn-effect2'></div>
          <img src={HelpBtn} onClick={() => showModal()} />
          <div className='help-content'>Do you need help?</div>
        </div>
        {dropIndex[0] !== 0 && dropIndex[1] !== 0 && dropIndex[2] !== 0 && (
          <div
            className="assessment-next-btn"
            onClick={() => {
              nextStep()
            }}
          >
            Next{" "}
            <div
              style={{
                paddingTop: "5px",
                display: "inline-block",
              }}
            >
              <FaChevronRight color="white" size={16} />
            </div>
          </div>
        )}
      </div>

      <Modal
        open={open}
        onOk={() => showModal()}
        onCancel={() => hideModal()}
        closeIcon={<img src={Close}></img>}
        footer={null}
      >
        <div className="direction-modal-container">
          <div className='direction-modal-title'>Directions</div>
          <div className='direction-modal-content'>
            Your love interest enters your restaurant with five other guests.  As a waiter at a high-end restaurant, you know it’s important to be aware of the emotional state of each guest.  Here’s your chance to put your skills to the test! Choose the word or phrase that best describes the  emotional state of each guest.
          </div>
        </div>
      </Modal>
    </div>
  )
}

// Scored wrapper for cognitive assessment (Module 1B - Food Preferences)
export const ScoredModule1_4 = (props) => (
  <AssessmentWrapper 
    moduleType="1B" 
    isAdaptive={false}
    onModuleComplete={props.onModuleComplete}
  >
    <Index {...props} />
  </AssessmentWrapper>
);
